export default __webpack_public_path__ + "static/media/dont-work-vehicle.a411f5d2.svg";